import ChoiceStore from "data/meta/ChoiceStore";
import { optionLabel } from "data/selectors/options";
import EntityProxy from "data/util/EntityProxy";
import StereotypeProxy from "data/util/StereotypeProxy";
import TableProxy from "data/util/TableProxy";

// noinspection JSUnresolvedVariable
ArmusScript = (function(base) { // eslint-disable-line no-native-reassign
    const ArmusScript = base || {};

    if (typeof Backbone !== "undefined") {
        _.each(ArmusScript, function(f, it) {
            if (it.indexOf("Array<") >= 0) {
                // it has an array argument
                ArmusScript[it] = function() {
                    const args = _.toArray(arguments);
                    const l = args.length;
                    for (let i = 0; i < l; i++) {
                        if (args[i] instanceof Backbone.Collection) {
                            args[i] = args[i].models;
                        }
                    }
                    return f.apply(this, args);
                };
            }
        });
    }

    // ensure operand(s) are numeric (not strings) in development
    if (process.env.NODE_ENV !== "production") {
        _.each([
            "_op_unary_minus",
            "_op_unary_plus",
            "_op_add",
            "_op_minus",
            "_op_multiply",
            "_op_divide",
            "_op_modulo",
        ], function(it) {
            const f = ArmusScript[it];
            ArmusScript[it] = function() {
                const args = _.toArray(arguments);
                const l = args.length;
                for (let i = 0; i < l; i++) {
                    if (typeof args[i] === "string") {
                        throw new Error(`Call to '${it}' was passed a string '${args[i]}'`);
                    }
                }
                return f.apply(this, args);
            };
        });
    }

    ArmusScript._op_get_at = function(a, i) {
        // in Hybrid-land, arrays are Backbone.Collection, not real
        if (a == null || i == null) {
            return null;
        }
        return a instanceof Backbone.Collection ? a.at(i) : a[i];
    };

    ArmusScript["isSameRecord(T,T)"] = function(a, b) {
        if (a == null) {
            return b == null;
        } else if (b == null) {
            return false;
        }
        if (a instanceof TableProxy || a instanceof EntityProxy || a instanceof StereotypeProxy) {
            return a.equals(b);
        }
        throw new Error("Cannot test 'isSameRecord(" + a + ", " + b + ")', try '=='.");
    };

    ArmusScript["toOptionLabel(String,String)"] = function(v, choicename) {
        if (v == null || choicename == null) {
            return v;
        }
        return optionLabel(choicename)(v) || v;
    };

    ArmusScript["toOptionName(int,String)"] = function(id, choicename) {
        return ChoiceStore.optionName(choicename)(id);
    };

    ArmusScript._traverse = function(curr, parts) {
        let i, part, next;
        const l = parts.length;
        for (i = 0; i < l && curr != null; i++) {
            part = parts[i];
            next = curr.get(part);
            if (curr instanceof TableProxy || curr instanceof EntityProxy || curr instanceof StereotypeProxy) {
                if (typeof next === "string" && curr.getAttributeType(part) === "DECIMAL") {
                    curr = Number(next);
                } else {
                    curr = next;
                }
            } else {
                curr = next;
            }
        }
        if (curr === undefined) {
            curr = null;
        }
        return curr;
    };

    const coreToString = ArmusScript["toString(T)"];
    ArmusScript["toString(T)"] = function(v) {
        if (v instanceof EntityProxy || v instanceof StereotypeProxy) {
            return v.getLabel();
        }
        return coreToString(v);
    };

    return ArmusScript;
}(ArmusScript));



// WEBPACK FOOTER //
// ./app/jsmodel/armusscript_extensions.js